var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Categories",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0Z",
    "data-name": "Path 3724"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M15.278 20.72a3.086 3.086 0 0 1-.621-.9H8.409a2.706 2.706 0 0 1-2.7-2.7V8.267a3 3 0 0 1 .895-5.865 3 3 0 0 1 .908 5.859v1.951h7.025a2.99 2.99 0 1 1 .006 1.8H7.512v5.106a.9.9 0 0 0 .9.9h6.047a3 3 0 1 1 .822 2.7Zm.922-2.121a1.2 1.2 0 1 0 1.2-1.2 1.2 1.2 0 0 0-1.2 1.197Zm0-7.5a1.2 1.2 0 1 0 1.2-1.2 1.2 1.2 0 0 0-1.2 1.197Zm-10.8-5.7a1.2 1.2 0 1 0 1.2-1.2 1.2 1.2 0 0 0-1.2 1.197Z",
    "data-name": "Path 3355",
    className: "color525863 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/Categories.6702fad6d30a9a0524ec0b588ab53922.svg";
export { ForwardRef as ReactComponent };